import { permissions, RTM_SERVICE_NAME, RtmPermission } from 'modules/auth/auth'

export const hasPermission = (requiredPermission: RtmPermission) => {
  return permissions.hasPermission({
    service: RTM_SERVICE_NAME,
    value: requiredPermission,
  })
}

export const hasEveryPermission = (requiredPermissions: RtmPermission[]) => {
  return requiredPermissions.every(permission => hasPermission(permission))
}

export const hasSomePermission = (requiredPermissions: RtmPermission[]) => {
  return requiredPermissions.some(permission => hasPermission(permission))
}
